module.exports = __webpack_public_path__ + "static/media/CourseNewCourse.9920e8e1.svg";